import { Kicker } from "../Kicker/Kicker";
import classNames from "classnames/bind";
import { Children, ReactNode } from "react";
import styles from "./SectionIntro.module.css";

const cx = classNames.bind(styles);

type SectionIntroProps = {
  variant: "centered" | "split";
  kicker?: string | null;
  headline: string;
  children?: ReactNode;
};

export function SectionIntro({
  variant,
  kicker,
  headline,
  children,
}: SectionIntroProps) {
  return (
    <div className={cx("section-intro")} data-variant={variant}>
      {kicker && <Kicker text={kicker} />}
      <div className={cx("intro")}>
        <h2 className={cx("headline")}>{headline}</h2>
        {Children.toArray(children).length ? (
          <div className={cx("body")}>{children}</div>
        ) : null}
      </div>
    </div>
  );
}
